import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import { validateProps } from '../../../../utils/propValidator';

const propRules = {
  checked: { type: 'boolean' },
  onChange: { type: 'function' },
  labelBefore: { type: 'string' },
  labelAfter: { type: 'string' },
  stackSx: { type: 'object' },
};

export default function StyledSwitch(props: any) {
  validateProps(props as Record<string, unknown>, propRules, 'StyledSwitch', { allowUnknown: true });
  const { checked, onChange, stackSx, labelBefore, labelAfter, ...rest } = props;
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        gap: 1.5,
        justifyItems: 'center',
        ...stackSx,
      }}
    >
      {labelBefore && <span>{labelBefore}</span>}
      <Switch checked={checked} onChange={onChange} {...rest} />
      {labelAfter && <span>{labelAfter}</span>}
    </Box>
  );
}
